import { Component, OnInit, ViewChild, inject, DestroyRef, TemplateRef, Input, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { BreadcrumbItem } from '../../models/breadcrumb/breadcrumb-item';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { AuditService } from 'src/app/services/api/audit.service';
import { translate } from '@jsverse/transloco';
import { AuditDetailsDialogComponent } from '../audit-mgmt-details/audit-details-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { ManageColumnsComponent } from 'src/app/components/manage-columns/manage-columns.component';
import { AuditFilterComponent } from '../audit-filter/audit-filter.component';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Permissions } from '../../models/principal/permission';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.AUDIT_READ,
    action: Permissions.AUDIT_READ
  }
];

@Component({
  selector: 'app-audit-mgmt',
  templateUrl: './audit-mgmt.component.html',
  styleUrls: ['./audit-mgmt.component.scss'],
  standalone: false
})
export class AuditMgmtComponent implements OnInit {
  @ViewChild(MatTable) table!: MatTable<any>;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('detailsDialog') detailsDialog!: TemplateRef<any>;
  private destroyRef = inject(DestroyRef);
  @Input() length: number = 0;
    
  DeployStatus = DeployStatus;
  breadcrumbItems: BreadcrumbItem[];
  dataSource = new MatTableDataSource<any>([]);
  total = 0;
  pageIndex = 0;
  paginationSize = 10;
  recordsPerAPI = 10000;
  showSpinner = true;
  showPagination = false;
  isFailed = false;
  dashboardLink: { label: string; };
  auditLink: { label: string; url: string[]; };
  tenantId: any;
  auditLoading = false;
  auditData: any[] = [];
  allAuditData: any[] = [];
  filteredData: any[] = [];
  currentFilter: string = '';
 private isFetchingAll = false;
  displayedColumns: string[] = [];
  dropdownsList: any = [];
  clearData: boolean;
  status: any;
  action: any;
  initiatedBy: any;
  initiatedByOptions: any;
  actionOptions: any;
  tenantIdOptions: any;
  statusOptions: any;
  data: any[];
  statusList: any;
  auditColumnDefs = [
    { key: 'tenantId', label: 'Tenant Name', visible: true, disable: true },
    { key: 'action', label: 'Action', visible: true },
    { key: 'timestamp', label: 'Timestamp', visible: true },
    { key: 'userEmail', label: 'Initiated by', visible: true },
    { key: 'status', label: 'Status', visible: true, disable: true },
    { key: 'details', label: '', visible: true, fixed: true },
  ];
  sortInfo: any;
  dataLoaded = false;
  permissionsMap: { [key: string]: boolean };

  constructor(
    private route: ActivatedRoute, private auditService: AuditService, private customToastrService: CustomToastrService, private router: Router,
    private sidenavService: SidenavService, private dialog: MatDialog, private cdr: ChangeDetectorRef, private permissionsService: PermissionsService,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
    if (!this.permissionsMap[PermissionKeys.AUDIT_READ]) {
        this.router.navigate(['/', this.authService.principal.provider, 'permission-unauthorized'], {skipLocationChange: true});
    }
    this.sidenavService.selectedMenu = 'LEFT_SIDE_NAV.AUDIT_DASHBOARD';
    this.pageIndex = 0;
    this.dashboardLink = ({ label: translate('LEFT_SIDE_NAV.DASHBOARDS') });
    this.auditLink = ({ label: translate('LEFT_SIDE_NAV.AUDIT_DASHBOARD'), url: ['audit-dashboard'] });
    const statusOptions = [
      {value: translate('TEST_RESULTS.SUCCESS'), label: translate('TEST_RESULTS.SUCCESS'), selected: false},
      {value: translate('TEST_RESULTS.FAILED'), label: translate('TEST_RESULTS.FAILED'), selected: false}
    ];

    const initiatedRaw = localStorage.getItem('auditFilteredInitiatedBy');
  if (initiatedRaw) {
    try {
       this.initiatedBy = JSON.parse(initiatedRaw);
    } catch {
    this.initiatedBy = initiatedRaw.split(',').map(x => x.trim());
  }
  } else {
  this.initiatedBy = undefined;
  }

  const actionRaw = localStorage.getItem('auditFilteredByAction');
  if (actionRaw) {
    try {
      this.action = JSON.parse(actionRaw);
    } catch {
     this.action = actionRaw.split(',').map(x => x.trim());
    }
  } else {
    this.action = undefined;
  }

  const tenantRaw = localStorage.getItem('auditFilteredByTenant');
  if (tenantRaw) {
    try {
      this.tenantId = JSON.parse(tenantRaw);
    } catch {
    this.tenantId = tenantRaw.split(',').map(x => x.trim());
    }
  } else {
    this.tenantId = undefined;
  }
   
  const statusRaw = localStorage.getItem('auditFilteredStatusTenant');
  if (statusRaw) {
    try {
      this.status = JSON.parse(statusRaw);
    } catch {
      this.status = statusRaw.split(',').map(x => x.trim());
    }
  } else {
  this.status = undefined;
  }

 

  this.dropdownsList = [
      {
        title: 'InitiatedBy',
        placeholder: translate('INSTANCE_DETAILS.INITIATED_BY'),
        key: 'userEmail',
        options: []
      },
      {
        title: 'Action',
        placeholder: translate('INSTANCE_DETAILS.ACTION'),
        key: 'action',
        options: []
      },
      {
        title: 'Tenant',
        placeholder: translate('INSTANCE_STATUS.TENANT'),
        key: 'tenant',
        options: []
      },
      {
        title: 'Status',
        placeholder: translate('INSTANCE_LIST.SELECT_STATUS'),
        key: 'status',
        options: statusOptions
      },
    ];

    this.displayedColumns = this.auditColumnDefs
      .filter(col => col.visible)
      .map(col => col.key);
    this.breadcrumbs();
    this.allAuditData = [];
    this.filteredData = [];
    this.total = 0;
     this.route.params
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(() => {
      this.getAllAuditLogs('', true);
    });
  }

  /* Cleans up resources when the component is destroyed */
  ngOnDestroy(): void {
  this.allAuditData = [];
  this.filteredData = [];
  this.total = 0;
  this.isFetchingAll = false;
}

  /* Opens the column settings dialog for the Audit Logs table.*/
  openAuditColumnSettings(): void {
    const userCols = this.auditColumnDefs
      .filter(col => !col.fixed)
      .map(col => ({ ...col, name: col.label }));
    const dialogRef = this.dialog.open(ManageColumnsComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '754px',
      autoFocus: false,
      data: {
        title: translate('MANAGE_COLUMNS.TITLE'),
        subTitle: translate('MANAGE_COLUMNS.SUBTITLE'),
        columns: userCols,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    });
    dialogRef.afterClosed().subscribe((updatedColumns) => {
      if (updatedColumns) {
        this.auditColumnDefs = this.auditColumnDefs.map(col => {
          if (col.fixed) return col;
          const updated = updatedColumns.find((u: any) => u.key === col.key);
          return updated ? { ...col, visible: updated.visible } : col;
        });
        this.displayedColumns = this.auditColumnDefs
          .filter(c => c.visible)
          .map(c => c.key);
        localStorage.setItem('console-auditcols', JSON.stringify(updatedColumns));
      }
    });
  }

  /* Handles pagination change event for the Audit Logs table */
  pageChanged(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
    if (this.currentFilter || this.initiatedBy?.length || this.action?.length || this.tenantId?.length || this.status?.length) {
      this.updateTable();
      this.updatePagedData();
    } else {
      this.updateTable();
    }
  }

  /* Resets all applied filters to their default state */
  resetFilter(): void {
    this.initiatedBy = undefined;
    this.tenantId = undefined;
    this.action = undefined;
    this.status = undefined;
    this.clearData = false;

  localStorage.removeItem('auditFilteredInitiatedBy');
  localStorage.removeItem('auditFilteredByAction');
  localStorage.removeItem('auditFilteredByTenant');
  localStorage.removeItem('auditFilteredStatusTenant');

  
    this.resetAllValues();

    this.currentFilter = '';

   this.pageIndex = 0;

 this.showSpinner = true;
  this.dataLoaded = false;

  setTimeout(() => {
    this.filteredData = [...this.allAuditData];
    this.total = this.filteredData.length;
    this.updatePagedData();

    this.showSpinner = false;
    this.isFailed = false;
    this.dataLoaded = true;
  }, 300);
  
  this.sidenavService.searchFilter.next('data');
  }

  resetAllValues(): void {
     this.dropdownsList.forEach(element => {
      element?.options?.forEach(item => {
        item.selected = false;
      });
    });
  }

  /* Opens the column filter dialog and optionally focuses on the given column */
  filterColumns(openKey?: 'initiatedBy' | 'action' | 'tenantId' | 'status'): void {
 
this.dropdownsList[0].options = this.initiatedByOptions?.map(value => ({
  value,
  selected: (this.initiatedBy || []).includes(value)
}));

this.dropdownsList[1].options = this.actionOptions?.map(value => ({
  value,
  selected: (this.action || []).includes(value)
}));

this.dropdownsList[2].options = this.tenantIdOptions?.map(value => ({
  value,
  selected: (this.tenantId || []).includes(value)
}));

this.dropdownsList[3].options = this.statusOptions?.map(value => ({
  value,
  selected: (this.status || []).includes(value)
}));
      const data = {
        name: translate('LEFT_SIDE_NAV.AUDIT_DASHBOARD'),
        title: translate('INSTANCE_STATUS.FILTER_TITLE'),
        subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
        filteredColumns: this.dropdownsList,
        initiatedBy: this.dropdownsList[0].options,
        action: this.dropdownsList[1].options,
        tenant: this.dropdownsList[2].options,
        status: this.dropdownsList[3].options,
        openDropdown: openKey,
      };      
      this.sidenavService.openInRightSidenav(AuditFilterComponent, data)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(filteredColumns => {
            if (filteredColumns) {
              this.clearData = true;
              this.showSpinner = true;
              this.tenantId = undefined;
            if (filteredColumns.initiatedBy?.length) {
              this.initiatedBy = [...filteredColumns.initiatedBy];
            } else {
              this.initiatedBy = undefined;
            }
            if (filteredColumns.action?.length) {
              this.action = [...filteredColumns.action];
            } else {
              this.action = undefined;
            }
            if (filteredColumns.tenant?.length) {
              this.tenantId = [...filteredColumns.tenant];
            } else {
              this.tenantId = undefined;
            }
            if (filteredColumns.status?.length) {
              this.status = [...filteredColumns.status];
            } else {
              this.status = undefined;
            }

            if (this.initiatedBy) {
              localStorage.setItem('auditFilteredInitiatedBy', JSON.stringify(this.initiatedBy));
            } else {
              localStorage.removeItem('auditFilteredInitiatedBy');
            }
            if (this.action) {
              localStorage.setItem('auditFilteredByAction', JSON.stringify(this.action));
            } else {
              localStorage.removeItem('auditFilteredByAction');
            }
            if (this.tenantId) {
              localStorage.setItem('auditFilteredByTenant', JSON.stringify(this.tenantId));
            } else {
              localStorage.removeItem('auditFilteredByTenant');
            }
            if (this.status) {
              localStorage.setItem('auditFilteredStatusTenant', JSON.stringify(this.status));
            } else {
              localStorage.removeItem('auditFilteredStatusTenant');
            }
              setTimeout(() => {
                this.applyAuditFilters();
            }, 300);
            }
          });
    }

    /* Handles the filters applied event and updates the table accordingly. */
    onFiltersApplied(filters: any): void {
    this.initiatedBy = [...(filters.initiatedBy || [])];
    this.action = [...(filters.action || [])];
    this.tenantId = [...(filters.tenant || [])];
    this.status = [...(filters.status || [])];

  if (this.initiatedBy?.length) {
    localStorage.setItem('auditFilteredInitiatedBy', JSON.stringify(this.initiatedBy));
  } else {
    localStorage.removeItem('auditFilteredInitiatedBy');
  }
  if (this.action?.length) {
    localStorage.setItem('auditFilteredByAction', JSON.stringify(this.action));
  } else {
    localStorage.removeItem('auditFilteredByAction');
  }
  if (this.tenantId?.length) {
    localStorage.setItem('auditFilteredByTenant', JSON.stringify(this.tenantId));
  } else {
    localStorage.removeItem('auditFilteredByTenant');
  }
  if (this.status?.length) {
    localStorage.setItem('auditFilteredStatusTenant', JSON.stringify(this.status));
  } else {
    localStorage.removeItem('auditFilteredStatusTenant');
  }
    this.applyAuditFilters();
}

/* Performs a search for instances based on the given event or input value */
    searchInstance(event?: any, exact: boolean = false): void {
    this.currentFilter = (event?.target?.value ?? '').toString().trim().toLowerCase();
    this.pageIndex = 0;
    if (this.paginator) this.paginator.firstPage();
    this.applyAuditFilters();
  }

  /* Map API item to table row */
  mapItem(item: any) {
  const status =
  (item.success === true || item.success === 'true') ? 'Success' :
  (item.success === false || item.success === 'false') ? 'Failed' : '-';
  const timestamp = item.timestamp ? new Date(item.timestamp) : null;
    return {
      id: item.id,
      tenantId: item.tenantId || "-",
      action: item.action || "-",
      timestamp: timestamp,
      userEmail: item.userEmail || "-",
      status: status,
      responseCode: item.responseCode || "-",
      httpMethod: item.httpMethod || "-",
      requestUri: item.requestUri || "-",
      requestBody:item.requestBody,
      responseBody:item.responseBody
    };
  }

  /*Fetch ALL pages from API.*/
  private getAllAuditLogs(searchValue: string, exact: boolean): void {
    if (this.isFetchingAll) {
      return;
    }
    this.isFetchingAll = true;
    let page = 0;
    const size = this.recordsPerAPI;
    const doFetch = (p: number) => {
      this.auditService.getAuditLog({ page: p, size })
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (data: any) => {
            if (data && data.data) {
              const mapped = (data.data || []).map((it: any) => this.mapItem(it));
              this.allAuditData = [...this.allAuditData, ...mapped];
              this.allAuditData.sort((a, b) => {
                const tb = b?.timestamp ? new Date(b.timestamp).getTime() : 0;
                const ta = a?.timestamp ? new Date(a.timestamp).getTime() : 0;
                return tb - ta; 
              });
              this.filteredData = this.applyFilter(this.allAuditData, searchValue, exact);
              this.updateTable();
              const hasNextFlag = (typeof data.hasNext === 'boolean') ? data.hasNext : undefined;
              const pagesCount = (typeof data.pages === 'number') ? Number(data.pages) : undefined;
              const totalFromResp = (typeof data.total === 'number') ? Number(data.total) : undefined;
              const limitFromResp = (typeof data.limit === 'number') ? Number(data.limit) : undefined;
              let shouldContinue = false;

            if (!this.currentFilter && (!this.initiatedBy?.length && !this.action?.length && !this.tenantId?.length && !this.status?.length)) {
            this.filteredData = [...this.allAuditData];
            this.dataSource.data = this.filteredData;
            this.updatePagedData();
            } else {
            this.applyAuditFilters();
            }
            this.buildDropdownOptions();
              if (typeof hasNextFlag === 'boolean') {
                shouldContinue = hasNextFlag;
              } else if (typeof pagesCount === 'number') {
                shouldContinue = p + 1 < pagesCount;
              } else if (totalFromResp && limitFromResp) {
                const lastPageIndex = Math.max(0, Math.ceil(totalFromResp / limitFromResp) - 1);
                shouldContinue = p < lastPageIndex;
              } else {
                shouldContinue = (data.data.length === size);
              }
              if (shouldContinue) {
                doFetch(p + 1);
              } else {
                this.total = this.filteredData.length;
                this.isFetchingAll = false;
                this.showSpinner = false;
                this.dataLoaded = true;
              }
            } else {
              this.total = this.filteredData.length;
              this.isFetchingAll = false;
              this.showSpinner = false;
              this.dataLoaded = true;
            }
          },
          error: (err) => {
            this.isFetchingAll = false;
            setTimeout(() => {
            this.showSpinner = false;
            this.isFailed = true;
            this.dataLoaded = true;
            this.cdr.detectChanges();
          });
            this.customToastrService.errMessage(err?.message || 'Error', translate("ERRORS.SERVICE_AVAILABILITY"));
          }
        });
    };
    doFetch(page);
  }

  /* Closes the menu and processes the provided data if necessary */
  closeMenu(data): void {
    this.sidenavService.searchFilter.next(data);
    this.filteredColumnsFunction(data);
  }

  /* Filters the table data based on the given column key (filterKey) */
  filteredColumnsFunction(filterKey: string): void {
    this.showSpinner = true;
    this.dataLoaded = false;
  switch (filterKey) {
    case 'initiatedBy':
      this.initiatedBy = undefined;
      this.resetValue(this.dropdownsList[0]);
      localStorage.removeItem('auditFilteredInitiatedBy');
      break;
    case 'action':
      this.action = undefined;
      this.resetValue(this.dropdownsList[1]);
      localStorage.removeItem('auditFilteredByAction');
      break;
    case 'tenantId':
      this.tenantId = undefined;
      this.resetValue(this.dropdownsList[2]);
      localStorage.removeItem('auditFilteredByTenant');
      break;
    case 'status':
      this.status = undefined;
      this.resetValue(this.dropdownsList[3]);
      localStorage.removeItem('auditFilteredStatusTenant');
      break;
  }

  setTimeout(() => {
    this.applyAuditFilters();
  }, 300);
}

  resetValue(closedItem): void {
    closedItem?.options?.forEach(element => {
      element.selected = false;
    });
  }

  /* Applies filtering on the provided data array based on filterValue */
  applyFilter(data: any[], filterValue: string, exact: boolean = false) {
    if (!filterValue) return [...data];
    const searchTerm = filterValue.trim().toLowerCase();
    if (exact) {
      const exactMatches = data.filter((item: any) =>
        item.tenantId?.toLowerCase() === searchTerm
      );
      if (exactMatches.length > 0) {
        return exactMatches;
      }
    }
    return data.filter((item: any) =>
      item.tenantId?.toLowerCase().includes(searchTerm) ||
      item.action?.toLowerCase().includes(searchTerm)
    );
  }

  /* Builds the list of options to be displayed in the dropdown */
   private buildDropdownOptions(): void {
              const Emails = this.allAuditData.map(item => item.userEmail).filter(email => !!email && email !== "-");
              this.initiatedByOptions = Array.from(new Set(Emails)).sort((a, b) => a.localeCompare(b));
              this.dropdownsList[0].options = this.initiatedByOptions.map(value => ({
                value,
                selected: false
              }));
              const Actions = this.allAuditData.map(item => item.action).filter(action => !!action && action !== "-");
              this.actionOptions = Array.from(new Set(Actions)).sort((a, b) => a.localeCompare(b));
              this.dropdownsList[1].options = this.actionOptions.map(value => ({
                value,
                selected: false
              }));
            const Tenants = this.allAuditData.map(item => item.tenantId).filter(tenant => !!tenant && tenant !== "-");
            this.tenantIdOptions = Array.from(new Set(Tenants)).sort((a, b) => a.localeCompare(b));
            this.dropdownsList[2].options = this.tenantIdOptions.map(value => ({
              value,
              selected: false
            }));
            const Statuses = this.allAuditData.map(item => item.status).filter(status => !!status && status !== "-");
            this.statusOptions = Array.from(new Set(Statuses)).sort((a, b) => a.localeCompare(b));
            this.dropdownsList[3].options = this.statusOptions.map(value => ({
              value,
              selected: false
            }));
            this.cdr.detectChanges();
  }

  /* Applies the selected filters to the Audit Logs data */
  private applyAuditFilters(): void {
    const baseData = [...this.allAuditData];
    this.filteredData = baseData.filter(item => {
    const byInitiated = !this.initiatedBy?.length || this.initiatedBy.includes(item.userEmail);
    const byAction = !this.action?.length || this.action.includes(item.action);
    const byTenant = !this.tenantId?.length || this.tenantId.includes(item.tenantId);
    const byStatus = !this.status?.length || this.status.includes(item.status);
    return byInitiated && byAction && byTenant && byStatus;
  });

  if (this.currentFilter?.trim()) {
    const search = this.currentFilter.toLowerCase();
    this.filteredData = this.filteredData.filter(item =>
      item.tenantId?.toLowerCase().includes(search) ||
      item.action?.toLowerCase().includes(search)
    );
  }
  
  this.total = this.filteredData.length;
  this.pageIndex = 0;
  this.updatePagedData();
  if (this.paginator) {
    this.paginator.length = this.total;
    this.paginator.firstPage();
  }
  this.showSpinner = false;
  this.dataLoaded = true;
  this.isFailed = false;
}

/* Updates the table data based on the current page settings */
private updatePagedData(): void {
  const startIndex = this.pageIndex * this.paginationSize;
  const endIndex = startIndex + this.paginationSize;
  this.dataSource.data = [...this.filteredData.slice(startIndex, endIndex)];
  this.showPagination = this.total > this.paginationSize;
  setTimeout(() => {
  if (this.paginator) {
    this.paginator.length = this.total || 0;
  }
  });
  this.cdr.detectChanges();
}

  /** Update the table's data */
  updateTable(): void {
    this.filteredData = this.filteredData || [];
    const startIndex = this.pageIndex * this.paginationSize;
    const endIndex = startIndex + this.paginationSize;
    const pageData = this.filteredData.slice(startIndex, endIndex);
    this.dataSource.data = pageData;
    setTimeout(() => {
    this.total = this.currentFilter ? this.filteredData.length : this.total;
    this.showPagination = (this.currentFilter ? this.filteredData.length : this.total) > this.paginationSize;
    if (this.paginator) {
      this.paginator.length = this.total;
    }
    });
    this.cdr.detectChanges();
  }

  breadcrumbs(): void {
    this.breadcrumbItems = [];
    this.breadcrumbItems.push({ icon: 'home' }, { label: this.dashboardLink.label, url: [] }, {
      label: this.auditLink.label,
      url: this.auditLink.url
    });
  }
  
  /* sorting data in table */
  sortData(event: any): void {
    if (!this.filteredData) return;
    this.filteredData = this.filteredData.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'tenantId':
          comparatorResult = a?.tenantId?.localeCompare(b?.tenantId || '') || 0;
          break;
        case 'action':
          comparatorResult = a?.action?.localeCompare(b?.action || '') || 0;
          break;
        case 'timestamp':
          comparatorResult = new Date(a?.timestamp).getTime() - new Date(b?.timestamp).getTime() || 0;
          break;
        case 'userEmail':
          comparatorResult = a?.userEmail?.localeCompare(b?.userEmail || '') || 0;
          break;
        case 'status':
          comparatorResult = a?.status?.localeCompare(b?.status || '') || 0;
          break;
        default:
          comparatorResult = 0;
          break;
      }
      if (a?.[event.active] === '-' && b?.[event.active] !== '-') {
        return event.direction === 'asc' ? 1 : -1;
      }
      if (b?.[event.active] === '-' && a?.[event.active] !== '-') {
        return event.direction === 'asc' ? -1 : 1;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
    });
    this.updateTable();
  }

  /* on click of view details for Audit*/
  viewAuditDetails(audit: any): void {
    const auditId = audit.id;
    this.sidenavService.openInRightSidenav(AuditDetailsDialogComponent, {
      auditData: {
        auditId,
        tenantId: audit.tenantId,
        action: audit.action,
        timestamp: audit.timestamp,
        status: audit.status,
        responseCode: audit.responseCode,
        httpMethod: audit.httpMethod,
        userEmail: audit.userEmail,
        requestUri: audit.requestUri,
        requestBody: audit?.requestBody,
        responseBody: audit?.responseBody
      }
    });
  }
}